// extracted by mini-css-extract-plugin
export var button = "_e-0";
export var buttonContent = "_e-e";
export var buttonGroup = "_e-c";
export var dontRestrainIconWidth = "_e-a";
export var dropdownButton = "_e-b";
export var iconContainer = "_e-9";
export var lg = "_e-4";
export var md = "_e-3";
export var pending = "_e-f";
export var sm = "_e-2";
export var spinner = "_e-d";
export var squared = "_e-8";
export var wrapText = "_e-g";
export var xl = "_e-5";
export var xs = "_e-1";
export var xxl = "_e-6";
export var xxxl = "_e-7";